import Phaser from 'phaser'
import {
    CST
} from '../CST'

var clickSound;

export default class TeamsScene extends Phaser.Scene {
    constructor() {
        super(CST.SCENES.TEAMS)
    }

    preload() {}

    create() {
        clickSound = this.sound.add("clickSound");

        this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, "main_background");

        var n = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2 - 200, "btn_teams2");
        n.setInteractive({
            useHandCursor: true
        });
        n.on("pointerdown", () => {
            clickSound.play();
            this.scene.stop(), this.scene.start(CST.SCENES.NAMES, {
                data: 2
            })
        });

        var r = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, "btn_teams3");
        r.setInteractive({
            useHandCursor: true
        });
        r.on("pointerdown", () => {
            clickSound.play();
            this.scene.stop(), this.scene.start(CST.SCENES.NAMES, {
                data: 3
            })
        })

        var x = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2 + 200, "btn_teams4");
        x.setInteractive({
            useHandCursor: true
        });
        x.on("pointerdown", () => {
            clickSound.play();
            this.scene.stop(), this.scene.start(CST.SCENES.NAMES, {
                data: 4
            })
        })
    }
}